export enum NotificationActionTypes {
  GET_NOTIFICATIONS_PENDING = '@@notification/GET_NOTIFICATIONS_PENDING',
  GET_NOTIFICATIONS_SUCCESS = '@@notification/GET_NOTIFICATIONS_SUCCESS',
  GET_NOTIFICATIONS_ERROR = '@@notification/GET_NOTIFICATIONS_ERROR'
}
